module.exports = __webpack_public_path__ + "img/pic-640-1.2e3f36d1.webp";